exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.app-breadcrumb.el-breadcrumb[data-v-b50ef614]{display:inline-block;font-size:14px;line-height:50px;margin-left:10px\n}\n.app-breadcrumb.el-breadcrumb .no-redirect[data-v-b50ef614]{color:#97a8be;cursor:text\n}", "", {"version":3,"sources":["/Applications/我的磁盘/F盘Project/商城-越南版/mall-admin-web/src/components/Breadcrumb/index.vue"],"names":[],"mappings":";AAwCA,+CACE,qBACA,eACA,iBACA,gBAAA;CACA;AAAA,4DACE,cACA,WAAA;CAAA","file":"index.vue","sourcesContent":["\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n.app-breadcrumb.el-breadcrumb {\n  display: inline-block;\n  font-size: 14px;\n  line-height: 50px;\n  margin-left: 10px;\n  .no-redirect {\n    color: #97a8be;\n    cursor: text;\n  }\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-b50ef614","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/dist/cjs.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Breadcrumb/index.vue
// module id = 6E4z
// module chunks = 72